import { SvgIcon } from '@mui/material';

export default function LaneRightHandIcon(props) {
  return (
    <SvgIcon fill='none' fontSize='large' {...props}>
      <path
        d='m 12.3277,23.0004 -0.7077,-0.7077 4.5942,-4.6 -4.5942,-4.6 0.7077,-0.7077 5.3077,5.3077 z m 6.1,0 -0.7077,-0.7077 4.5942,-4.6 -4.5942,-4.6 0.7077,-0.7077 5.3077,5.3077 z'
        id='path1'
      />
      <path
        d='M 6.16769,11.6154 0.859993,6.3077 6.16769,1 l 0.7077,0.7077 -4.59422,4.6 4.59422,4.6 z m 6.10001,0 L 6.95999,6.3077 12.2677,1 l 0.7077,0.7077 -4.59423,4.6 4.59423,4.6 z'
        id='path2'
      />
    </SvgIcon>
  );
}
